const readMore = {
  wrap: document.querySelectorAll('.jsReadMore') as NodeListOf<HTMLElement>,

  init() {
    this.setBtn();
  },

  setBtn() {
    this.wrap.forEach((item) => {
      const elWrap = item.querySelector('.jsReadMoreWrap') as HTMLElement;
      const elBody = item.querySelector('.jsReadMoreBody') as HTMLElement;
      const btn = item.querySelector('.jsReadMoreTrigger') as HTMLElement;
      const height = elBody.offsetHeight;
      const itemHeight = elWrap.offsetHeight;

      if (!btn) return;
      if (height <= itemHeight) {
        btn.classList.add('d-none');
      }
      btn.addEventListener('click', () => {
        if (btn.dataset.open === 'false') {
          btn.dataset.open = 'true';
          elWrap.style.maxHeight = height + 30 + 'px';
          btn.innerText = 'Read Less ';
        } else {
          btn.dataset.open = 'false';
          elWrap.style.maxHeight = itemHeight + 'px';
          btn.innerText = 'Read More';
        }
      });
    });
  },
};

export default readMore;
